import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default DatePicker;

export const popperModifiers = [
    {
        name: 'preventOverflow',
        options: {
            enabled: true,
            escapeWithReference: false,
            boundariesElement: 'viewport',
        }
    }
];
